'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeSections = require('@shopify/theme-sections');

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.register)('featured-collection', {
  onLoad: function onLoad() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _this;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;

              _this2.sliders();

              $(window).on("resize orientationchange", function () {
                app.productsSwiper.destroy();
                _this.sliders();
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  sliders: function sliders() {
    app.productsSwiper = new _swiper2.default('.swiper-products', {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 32,
      observer: true,
      observeParents: true,
      allowTouchMove: false,
      breakpoints: {
        767: {
          autoHeight: true,
          slidesPerView: 1,
          allowTouchMove: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: 'true'
          }
        },
        992: {
          allowTouchMove: true,
          slidesPerView: 2
        },
        1300: {
          allowTouchMove: false,
          slidesPerView: 3
        }
      }
    });
  }
});